module.exports = __webpack_public_path__ + "static/media/TTBlack.cb20c59c.svg";